import { Switch, useRouteMatch } from 'react-router-dom';

import AuthenticatedPrivateRoute from '../../../AuthenticatedPrivateRoute';
import AddAdjustment from './AddAdjustment';
import EditAdjustment from './EditAdjustment';
import ViewAdjustments from './ViewAdjustments';

function AdjustmentsPages() {
    const { path } = useRouteMatch();
    return (
        <Switch>
            <AuthenticatedPrivateRoute path={`${path}/add`} component={AddAdjustment}/>
            <AuthenticatedPrivateRoute path={`${path}/edit/:adjustmentId`} component={EditAdjustment}/>
            <AuthenticatedPrivateRoute path={`${path}`} component={ViewAdjustments}/>
        </Switch>
    );
}

export default AdjustmentsPages;
